import Store from 'lib/Store/withLocalStorage';

import config from 'config/general';

const authStore = Store(`${config.localStorageKey}-auth`);

export const middlewareUser = (data: any): IUser => ({
  cacheKey: authStore.getItem('token') || data?.id || '',

  user: {
    id: data?.id || '',
    email: data?.email || '',
    phone: data?.phone || '',
    name: data?.name || '',
    lastname: data?.lastname || '',
    fullname: `${data?.name} ${data?.lastname}` || '',
    role: data?.role || '',
    site: data?.site || '',
    about: data?.about || '',
    avatar: data?.profile_image || '',
    observation: data?.observation || '',
    companyFantasyName: data?.company || '',
    type: data?.white_label_type || '',
    language: data?.language || '',
    table: '',
  },

  typeUser: data?.white_label_type || '',
  interests: data?.surveys_answers || [],
});
